import { render, staticRenderFns } from "./EditPeriodiciteModal.vue?vue&type=template&id=60753dfc&scoped=true&"
import script from "./EditPeriodiciteModal.vue?vue&type=script&lang=ts&"
export * from "./EditPeriodiciteModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditPeriodiciteModal.vue?vue&type=style&index=0&id=60753dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60753dfc",
  null
  
)

export default component.exports